class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.autoCloseTimer = null;

    this.notification.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener(
        'click',
        this.close.bind(this)
      )
    );
  }


  open() {
    this.notification.classList.add(
      'animate',
      'active'
    );

    /*
      Fermeture automatique après 7 secondes
    */

    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
    }

    this.autoCloseTimer = setTimeout(() => {
      this.close();
    }, 7000);


    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );


    document.body.addEventListener(
      'click',
      this.onBodyClick
    );


    this.dispatchCartViewEvent();
  }


  async dispatchCartViewEvent() {
    const { CartViewEvent } =
      window.StandardEvents || {};

    if (!CartViewEvent) return;


    try {
      const response =
        await fetch(`${routes.cart_url}.json`);

      const cart =
        await response.json();


      if (!cart?.currency) return;


      this.dispatchEvent(
        new CartViewEvent({
          context: 'dialog',
          cart:
            CartViewEvent.createCartFromAjaxResponse(
              cart
            ),
        })
      );

    } catch (e) {
      // cart:view est informatif uniquement
    }
  }


  close() {
    this.notification.classList.remove(
      'active'
    );


    document.body.removeEventListener(
      'click',
      this.onBodyClick
    );


    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }


    removeTrapFocus(
      this.activeElement
    );
  }


  updateLogisticsMessages() {
    const shippingMessage =
      document.getElementById(
        'infini-notification-shipping-text'
      );

    const pickupMessage =
      document.getElementById(
        'infini-notification-retrait-text'
      );


    if (!shippingMessage && !pickupMessage) return;


    /*
      Heure française réelle
    */

    const formatter =
      new Intl.DateTimeFormat(
        'en-US',
        {
          timeZone: 'Europe/Paris',
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        }
      );


    const parts =
      formatter.formatToParts(
        new Date()
      );


    const day =
      parts.find(
        part =>
          part.type === 'weekday'
      ).value;


    const hour =
      parseInt(
        parts.find(
          part =>
            part.type === 'hour'
        ).value,
        10
      );


    const minute =
      parseInt(
        parts.find(
          part =>
            part.type === 'minute'
        ).value,
        10
      );


    const timeInMinutes =
      (hour * 60) + minute;


    /*
      ==========================
      EXPÉDITION
      ==========================

      Cutoff :
      mercredi 19h
    */

    const expeditionCutoff =
      19 * 60;


    const expeditionLundi =
      (
        day === 'Wed' &&
        timeInMinutes >= expeditionCutoff
      )
      ||
      day === 'Thu'
      ||
      day === 'Fri'
      ||
      day === 'Sat'
      ||
      day === 'Sun';


    if (shippingMessage) {

      if (expeditionLundi) {

        shippingMessage.innerHTML = `
          Expédition
          <strong style="color:#E85C33;">
            lundi
          </strong>
          pour préserver la fraîcheur.
        `;

      } else {

        shippingMessage.innerHTML = `
          Livraison express généralement sous
          <strong style="color:#E85C33;">
            24 à 48h
          </strong>.
        `;

      }
    }


    /*
      ==========================
      CLICK & COLLECT
      ==========================

      Retraits :
      mardi ou vendredi

      Cutoff :
      19h
    */

    const pickupCutoff =
      19 * 60;


    let prochainRetrait = '';


    if (
      (
        day === 'Thu' &&
        timeInMinutes >= pickupCutoff
      )
      ||
      day === 'Fri'
      ||
      day === 'Sat'
      ||
      day === 'Sun'
      ||
      (
        day === 'Mon' &&
        timeInMinutes < pickupCutoff
      )
    ) {

      prochainRetrait = 'mardi';

    } else {

      prochainRetrait = 'vendredi';

    }


    if (pickupMessage) {

      pickupMessage.innerHTML = `
        Prochain retrait possible :
        <strong style="color:#E85C33;">
          ${prochainRetrait}
        </strong>.
      `;

    }
  }


  renderContents(parsedState) {
    this.cartItemKey =
      parsedState.key;


    this.getSectionsToRender().forEach(
      (section) => {

        document.getElementById(
          section.id
        ).innerHTML =
          this.getSectionInnerHTML(
            parsedState.sections[
              section.id
            ],
            section.selector
          );

      }
    );


    if (this.header) {
      this.header.reveal();
    }


    /*
      Met à jour les infos
      Expédition + Click & Collect
      avant affichage
    */

    this.updateLogisticsMessages();


    this.open();
  }


  getSectionsToRender() {
    return [
      {
        id:
          'cart-notification-product',

        selector:
          `[id="cart-notification-product-${this.cartItemKey}"]`,
      },

      {
        id:
          'cart-notification-button',
      },

      {
        id:
          'cart-icon-bubble',
      },
    ];
  }


  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {

    return new DOMParser()
      .parseFromString(
        html,
        'text/html'
      )
      .querySelector(
        selector
      )
      .innerHTML;

  }


  handleBodyClick(evt) {
    const target =
      evt.target;


    if (
      target !== this.notification &&
      !target.closest(
        'cart-notification'
      )
    ) {

      const disclosure =
        target.closest(
          'details-disclosure, header-menu'
        );


      this.activeElement =
        disclosure
          ? disclosure.querySelector(
              'summary'
            )
          : null;


      this.close();
    }
  }


  setActiveElement(element) {
    this.activeElement =
      element;
  }
}


customElements.define(
  'cart-notification',
  CartNotification
);